import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { PRODUCTS, DEFAULT_SITE_LINKS } from "@/data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ContentContext = createContext({ loaded: false });

export const SITE_LINKS = { ...DEFAULT_SITE_LINKS };

export const ContentProvider = ({ children }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/content`)
      .then(({ data }) => {
        const overrides = data?.products || {};
        Object.entries(overrides).forEach(([slug, fields]) => {
          const idx = PRODUCTS.findIndex((p) => p.slug === slug);
          if (idx === -1) return;
          const p = PRODUCTS[idx];
          if (fields.visible === false) {
            PRODUCTS.splice(idx, 1);
            return;
          }
          if (fields.name) p.name = fields.name;
          if (fields.appUrl !== undefined) p.appUrl = fields.appUrl;
          if (fields.tagline_en) p.tagline.en = fields.tagline_en;
          if (fields.tagline_bm) p.tagline.bm = fields.tagline_bm;
          if (fields.desc_en) p.desc.en = fields.desc_en;
          if (fields.desc_bm) p.desc.bm = fields.desc_bm;
        });
        Object.assign(SITE_LINKS, data?.links || {});
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  if (!loaded) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#07090E]">
        <img src="/logo-full.png" alt="OTOSUBS" className="h-12 w-auto animate-pulse" />
      </div>
    );
  }
  return <ContentContext.Provider value={{ loaded }}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext);
